export const routes = [
  {
    path: '/Abfallaufkommen',
    name: 'Abfallaufkommen',
    component: () => import('/app/src/pages/Abfallaufkommen.vue'),
    /* no children */
  },
  {
    path: '/Abfallbehaelter',
    name: 'Abfallbehaelter',
    component: () => import('/app/src/pages/Abfallbehaelter.vue'),
    /* no children */
  },
  {
    path: '/Abfallentwicklung',
    name: 'Abfallentwicklung',
    component: () => import('/app/src/pages/Abfallentwicklung.vue'),
    /* no children */
  },
  {
    path: '/Abfalllogistik',
    name: 'Abfalllogistik',
    component: () => import('/app/src/pages/Abfalllogistik.vue'),
    /* no children */
  },
  {
    path: '/Abfallrechtsregister',
    name: 'Abfallrechtsregister',
    component: () => import('/app/src/pages/Abfallrechtsregister.vue'),
    /* no children */
  },
  {
    path: '/Activate',
    /* internal name: 'Activate' */
    /* no component */
    children: [
      {
        path: ':id',
        name: 'Activation',
        component: () => import('/app/src/pages/Activate/[id].vue'),
        props: true,
        /* no children */
        meta: {
          "nonAuthRequired": true
        }
      }
    ],
  },
  {
    path: '/Admin',
    /* internal name: 'Admin' */
    /* no component */
    children: [
      {
        path: 'Auswertungen',
        name: 'Auswertungen',
        component: () => import('/app/src/pages/Admin/Auswertungen.vue'),
        props: true,
        /* no children */
        meta: {
          "nonAuthRequired": true
        }
      },
      {
        path: 'Benutzer',
        name: 'Benutzerübersicht',
        component: () => import('/app/src/pages/Admin/Benutzer.vue'),
        /* no children */
      },
      {
        path: 'Configuration',
        /* internal name: 'Configuration' */
        /* no component */
        children: [
          {
            path: ':slug',
            name: '[slug]',
            component: () => import('/app/src/pages/Admin/Configuration/[slug].vue'),
            props: true,
            /* no children */
            meta: {
              "nonAuthRequired": true
            }
          },
          {
            path: 'Abfallarten',
            name: 'Abfallarten',
            component: () => import('/app/src/pages/Admin/Configuration/Abfallarten.vue'),
            /* no children */
          },
          {
            path: 'AuditCheckliste',
            name: 'Auditcheckliste bearbeiten',
            component: () => import('/app/src/pages/Admin/Configuration/AuditCheckliste.vue'),
            /* no children */
          },
          {
            path: 'Auflagenvorlagen',
            name: 'Auflagenvorlagen',
            component: () => import('/app/src/pages/Admin/Configuration/Auflagenvorlagen.vue'),
            /* no children */
          },
          {
            path: 'CO2Preise',
            name: 'CO2Preise',
            component: () => import('/app/src/pages/Admin/Configuration/CO2Preise.vue'),
            props: true,
            /* no children */
            meta: {
              "nonAuthRequired": true
            }
          },
          {
            path: 'Einheiten',
            name: 'Einheiten',
            component: () => import('/app/src/pages/Admin/Configuration/Einheiten.vue'),
            props: true,
            /* no children */
            meta: {
              "nonAuthRequired": true
            }
          },
          {
            path: 'Einsatzstoffe',
            name: 'Einsatzstoffe',
            component: () => import('/app/src/pages/Admin/Configuration/Einsatzstoffe.vue'),
            /* no children */
          },
          {
            path: 'Emissionskategorien',
            name: 'Emissionskategorien',
            component: () => import('/app/src/pages/Admin/Configuration/Emissionskategorien.vue'),
            props: true,
            /* no children */
            meta: {
              "nonAuthRequired": true
            }
          },
          {
            path: 'Energiekategorie',
            name: 'Energiekategorie',
            component: () => import('/app/src/pages/Admin/Configuration/Energiekategorie.vue'),
            props: true,
            /* no children */
            meta: {
              "nonAuthRequired": true
            }
          },
          {
            path: 'Energietraeger',
            name: 'Energieträger',
            component: () => import('/app/src/pages/Admin/Configuration/Energietraeger.vue'),
            /* no children */
          },
          {
            path: 'FragebogenNachhaltigkeit',
            name: 'FragebogenNachhaltigkeit',
            component: () => import('/app/src/pages/Admin/Configuration/FragebogenNachhaltigkeit.vue'),
            /* no children */
          },
          {
            path: 'Heizgradtage',
            name: 'Heizgradtage',
            component: () => import('/app/src/pages/Admin/Configuration/Heizgradtage.vue'),
            props: true,
            /* no children */
            meta: {
              "nonAuthRequired": true
            }
          },
          {
            path: 'Produktionsrueckstaende',
            name: 'Produktionsrueckstaende',
            component: () => import('/app/src/pages/Admin/Configuration/Produktionsrueckstaende.vue'),
            /* no children */
          },
          {
            path: 'Programme',
            name: 'Programme',
            component: () => import('/app/src/pages/Admin/Configuration/Programme.vue'),
            props: true,
            /* no children */
            meta: {
              "nonAuthRequired": true
            }
          },
          {
            path: 'StandardHandlungsfeldeintraege',
            name: 'StandardHandlungsfeldeintraege',
            component: () => import('/app/src/pages/Admin/Configuration/StandardHandlungsfeldeintraege.vue'),
            props: true,
            /* no children */
            meta: {
              "nonAuthRequired": true
            }
          },
          {
            path: 'Umweltauswirkungen',
            name: 'Umweltauswirkungen',
            component: () => import('/app/src/pages/Admin/Configuration/Umweltauswirkungen.vue'),
            props: true,
            /* no children */
            meta: {
              "nonAuthRequired": true
            }
          }
        ],
      },
      {
        path: 'DekarbonisierungsstrategienAlle',
        name: 'DekarbonisierungsstrategienAlle',
        component: () => import('/app/src/pages/Admin/DekarbonisierungsstrategienAlle.vue'),
        props: true,
        /* no children */
        meta: {
          "nonAuthRequired": true
        }
      },
      {
        path: 'EnergietraegerAlle',
        name: 'EnergietraegerAlle',
        component: () => import('/app/src/pages/Admin/EnergietraegerAlle.vue'),
        props: true,
        /* no children */
        meta: {
          "nonAuthRequired": true
        }
      },
      {
        path: 'KlimabilanzenAlle',
        name: 'Klimabilanzen',
        component: () => import('/app/src/pages/Admin/KlimabilanzenAlle.vue'),
        props: true,
        /* no children */
        meta: {
          "nonAuthRequired": true
        }
      },
      {
        path: 'MassnahmenAlle',
        name: 'Massnahmen (Alle)',
        component: () => import('/app/src/pages/Admin/MassnahmenAlle.vue'),
        props: true,
        /* no children */
        meta: {
          "nonAuthRequired": true
        }
      },
      {
        path: 'MassnahmenBroschuere',
        name: 'Massnahmen (Broschüre)',
        component: () => import('/app/src/pages/Admin/MassnahmenBroschuere.vue'),
        props: true,
        /* no children */
        meta: {
          "nonAuthRequired": true
        }
      },
      {
        path: 'Navigation',
        name: 'Navigation bearbeiten',
        component: () => import('/app/src/pages/Admin/Navigation.vue'),
        /* no children */
      },
      {
        path: 'Teilnehmer',
        name: 'Teilnehmer',
        component: () => import('/app/src/pages/Admin/Teilnehmer.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/Anhaenge',
    name: 'Anhaenge',
    component: () => import('/app/src/pages/Anhaenge.vue'),
    /* no children */
  },
  {
    path: '/Anlagenteile',
    name: 'Anlagenteile',
    component: () => import('/app/src/pages/Anlagenteile.vue'),
    /* no children */
  },
  {
    path: '/AuditCheckliste',
    /* internal name: 'AuditCheckliste' */
    /* no component */
    children: [
      {
        path: ':checklisttype',
        name: '[checklisttype]',
        component: () => import('/app/src/pages/AuditCheckliste/[checklisttype].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/Auflagen',
    name: 'Auflagen',
    component: () => import('/app/src/pages/Auflagen.vue'),
    /* no children */
  },
  {
    path: '/Berichte',
    name: 'Berichte',
    component: () => import('/app/src/pages/Berichte.vue'),
    /* no children */
  },
  {
    path: '/Bescheide',
    name: 'Bescheide',
    component: () => import('/app/src/pages/Bescheide.vue'),
    /* no children */
  },
  {
    path: '/Betriebsprozesse',
    name: 'Betriebsprozesse',
    component: () => import('/app/src/pages/Betriebsprozesse.vue'),
    /* no children */
  },
  {
    path: '/Bezugsgroessen',
    name: 'Bezugsgroessen',
    component: () => import('/app/src/pages/Bezugsgroessen.vue'),
    /* no children */
  },
  {
    path: '/Datenschutz',
    name: 'Datenschutz',
    component: () => import('/app/src/pages/Datenschutz.vue'),
    /* no children */
    meta: {
      "nonAuthRequired": true
    }
  },
  {
    path: '/Dekarbonisierungsstrategie',
    name: 'Dekarbonisierungsstrategie',
    component: () => import('/app/src/pages/Dekarbonisierungsstrategie.vue'),
    /* no children */
  },
  {
    path: '/EcoDesignCheckliste',
    /* internal name: 'EcoDesignCheckliste' */
    /* no component */
    children: [
      {
        path: ':produktid',
        name: 'EcoDesignCheckliste',
        component: () => import('/app/src/pages/EcoDesignCheckliste/[produktid].vue'),
        props: true,
        /* no children */
      }
    ],
  },
  {
    path: '/Einsatzstoffverwendung',
    name: 'Einsatzstoffverwendung',
    component: () => import('/app/src/pages/Einsatzstoffverwendung.vue'),
    /* no children */
  },
  {
    path: '/Energie',
    name: 'Energie',
    component: () => import('/app/src/pages/Energie.vue'),
    /* no children */
  },
  {
    path: '/Gebaeude',
    name: 'Gebaeude',
    component: () => import('/app/src/pages/Gebaeude.vue'),
    /* no children */
  },
  {
    path: '/GroessteUmweltauswirkungen',
    name: 'GroessteUmweltauswirkungen',
    component: () => import('/app/src/pages/GroessteUmweltauswirkungen.vue'),
    /* no children */
  },
  {
    path: '/Grundstuecke',
    name: 'Grundstuecke',
    component: () => import('/app/src/pages/Grundstuecke.vue'),
    /* no children */
  },
  {
    path: '/Handlungsfelder',
    name: 'Handlungsfelder',
    component: () => import('/app/src/pages/Handlungsfelder.vue'),
    /* no children */
  },
  {
    path: '/Heizwaermebedarf',
    name: 'Heizwaermebedarf',
    component: () => import('/app/src/pages/Heizwaermebedarf.vue'),
    /* no children */
  },
  {
    path: '/Impressum',
    name: 'Impressum',
    component: () => import('/app/src/pages/Impressum.vue'),
    /* no children */
    meta: {
      "nonAuthRequired": true
    }
  },
  {
    path: '/Kennzahlen2',
    name: 'Kennzahlen2',
    component: () => import('/app/src/pages/Kennzahlen2.vue'),
    /* no children */
  },
  {
    path: '/Klimabilanz',
    name: 'Klimabilanz',
    component: () => import('/app/src/pages/Klimabilanz.vue'),
    /* no children */
  },
  {
    path: '/Kontakte',
    name: 'Kontakte',
    component: () => import('/app/src/pages/Kontakte.vue'),
    /* no children */
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('/app/src/pages/Login.vue'),
    /* no children */
    meta: {
      "nonAuthRequired": true
    }
  },
  {
    path: '/Me',
    name: 'Mein Profil',
    component: () => import('/app/src/pages/Me.vue'),
    /* no children */
  },
  {
    path: '/Modal_Split',
    name: 'Modal Split',
    component: () => import('/app/src/pages/Modal_Split.vue'),
    /* no children */
  },
  {
    path: '/Nachhaltigkeit',
    /* internal name: 'Nachhaltigkeit' */
    /* no component */
    children: [
      {
        path: 'Fragebogen',
        name: 'Fragebogen',
        component: () => import('/app/src/pages/Nachhaltigkeit/Fragebogen.vue'),
        /* no children */
      },
      {
        path: 'MitarbeiterStruktur',
        name: 'MitarbeiterStruktur',
        component: () => import('/app/src/pages/Nachhaltigkeit/MitarbeiterStruktur.vue'),
        /* no children */
      },
      {
        path: 'Politik',
        name: 'Politik',
        component: () => import('/app/src/pages/Nachhaltigkeit/Politik.vue'),
        /* no children */
      },
      {
        path: 'Programm',
        name: 'Programm',
        component: () => import('/app/src/pages/Nachhaltigkeit/Programm.vue'),
        /* no children */
      },
      {
        path: 'SDGs',
        name: 'SDGs',
        component: () => import('/app/src/pages/Nachhaltigkeit/SDGs.vue'),
        /* no children */
      },
      {
        path: 'Stakeholder',
        name: 'Stakeholder',
        component: () => import('/app/src/pages/Nachhaltigkeit/Stakeholder.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/Netzwerksuche',
    name: 'Netzwerksuche',
    component: () => import('/app/src/pages/Netzwerksuche.vue'),
    /* no children */
  },
  {
    path: '/Oekologische_Reinigung',
    name: 'Oekologische Reinigung',
    component: () => import('/app/src/pages/Oekologische_Reinigung.vue'),
    /* no children */
  },
  {
    path: '/Produkte_und_Dienstleistungen',
    name: 'Produkte und Dienstleistungen',
    component: () => import('/app/src/pages/Produkte_und_Dienstleistungen.vue'),
    /* no children */
  },
  {
    path: '/Produktionsrueckstandsaufkommen',
    name: 'Produktionsrueckstandsaufkommen',
    component: () => import('/app/src/pages/Produktionsrueckstandsaufkommen.vue'),
    /* no children */
  },
  {
    path: '/Protokoll',
    name: 'Protokoll',
    component: () => import('/app/src/pages/Protokoll.vue'),
    /* no children */
  },
  {
    path: '/Q-Check',
    name: 'Q-Check',
    component: () => import('/app/src/pages/Q-Check.vue'),
    /* no children */
  },
  {
    path: '/Raeume',
    name: 'Raeume',
    component: () => import('/app/src/pages/Raeume.vue'),
    /* no children */
  },
  {
    path: '/Recycling',
    name: 'Recycling',
    component: () => import('/app/src/pages/Recycling.vue'),
    /* no children */
  },
  {
    path: '/Sammelstellen',
    name: 'Sammelstellen',
    component: () => import('/app/src/pages/Sammelstellen.vue'),
    /* no children */
  },
  {
    path: '/Standort',
    name: 'Standort',
    component: () => import('/app/src/pages/Standort.vue'),
    /* no children */
  },
  {
    path: '/Standorte',
    name: 'Standorte',
    component: () => import('/app/src/pages/Standorte.vue'),
    /* no children */
  },
  {
    path: '/Teilnahmen',
    name: 'Teilnahmen',
    component: () => import('/app/src/pages/Teilnahmen.vue'),
    /* no children */
  },
  {
    path: '/Umweltaspektranking',
    name: 'Umweltaspektranking',
    component: () => import('/app/src/pages/Umweltaspektranking.vue'),
    /* no children */
  },
  {
    path: '/Umweltleistungen',
    name: 'Umweltleistungen',
    component: () => import('/app/src/pages/Umweltleistungen.vue'),
    /* no children */
  },
  {
    path: '/Umweltpolitik',
    name: 'Umweltpolitik',
    component: () => import('/app/src/pages/Umweltpolitik.vue'),
    /* no children */
  },
  {
    path: '/Umweltwirkungen',
    name: 'Umweltwirkungen',
    component: () => import('/app/src/pages/Umweltwirkungen.vue'),
    /* no children */
  },
  {
    path: '/Unternehmen',
    name: 'Unternehmen',
    component: () => import('/app/src/pages/Unternehmen.vue'),
    /* no children */
  },
  {
    path: '/Wasserverbrauch',
    name: 'Wasserverbrauch',
    component: () => import('/app/src/pages/Wasserverbrauch.vue'),
    /* no children */
  },
  {
    path: '/Zielgroessen',
    name: 'Zielgroessen',
    component: () => import('/app/src/pages/Zielgroessen.vue'),
    /* no children */
  },
  {
    path: '/ZweckDerAnlage',
    name: 'ZweckDerAnlage',
    component: () => import('/app/src/pages/ZweckDerAnlage.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

